// Single source of truth for the global keyboard shortcuts shown in the help dialog (?)
// and handled in AppShell's keydown listener. Keep the `key` values in sync with the
// switch there. Labels are English keys (i18n falls back to them).
export interface Shortcut {
  key: string; // displayed key cap
  label: string; // English description (i18n key)
}

export const SHORTCUTS: Shortcut[] = [
  { key: "⌘/Ctrl K", label: "Command palette" },
  { key: "/", label: "Focus search" },
  { key: "n", label: "New item" },
  { key: "u", label: "Copy username" },
  { key: "p", label: "Copy password" },
  { key: "[", label: "Toggle sidebar" },
  { key: "?", label: "Keyboard shortcuts" },
];
